<template>
  <div>
    <div class="softwareUpdate div-layout tab-resetStyle">
      <bannerManage :type-code="typeCode" />
    </div>
  </div>
</template>

<script>
import bannerManage from './bannerManage/index.vue';
export default {
  name: 'TeacherAssistantSoftwareUpdate',
  components: {
    bannerManage
  },
  data: () => {
    return {
      typeCode: 'B14'
    };
  }
};
</script>
